const VerticalLayout = () => import('@/layouts/VerticalLayout')

const customers = () => import('./views/index')
const managementlist = () => import('./views/management')

// Account (per-customer) detail shell + sub-pages
const accountsDetails = () => import('./views/accountsDetails')
const accountsDetailsPurchases = () => import('./views/accountsDetailsPurchases')
const accountsDetailsGifts = () => import('./views/accountsDetailsGifts')
const accountsDetailsServices = () => import('./views/accountsDetailsServices')

// Shared leaf pages (used by both the per-customer account detail and the
// global management view — they detect the mode from the presence of an :id).
const purchasesCurrent = () => import('./views/customerPurchase/current.vue')
const purchasesHistory = () => import('./views/customerPurchase/history.vue')
const giftsCurrent = () => import('./views/customerGifts/current.vue')
const giftsHistory = () => import('./views/customerGifts/history.vue')

// Management (global) shell
const management = () => import('./views/activity')

export default [
  {
    path: '/business/customers',
    name: 'BusinessCustomers',
    component: VerticalLayout,
    children: [{
      path: '',
      name: 'BusinessCustomers',
      component: customers,
      redirect: { name: 'customers.accounts' },
      meta: { name: 'customers', userType: 'provider', serviceTypes: 'all' },
      children: [
        {
          path: 'accounts',
          name: 'customers.accounts',
          component: managementlist,
          meta: { name: 'accounts', userType: 'provider', serviceTypes: 'all' }
        },
        {
          path: 'activity',
          name: 'customers.management',
          component: management,
          redirect: { name: 'customers.management.purchases' },
          meta: { name: 'management', userType: 'provider', serviceTypes: 'all' },
          children: [
            {
              path: 'purchases',
              name: 'customers.management.purchases',
              component: accountsDetailsPurchases,
              redirect: { name: 'customers.management.purchases.current' },
              meta: { name: 'purchases', userType: 'provider', serviceTypes: 'all' },
              children: [
                {
                  path: 'current',
                  name: 'customers.management.purchases.current',
                  component: purchasesCurrent,
                  meta: { name: 'current', userType: 'provider', serviceTypes: 'all' }
                },
                {
                  path: 'history',
                  name: 'customers.management.purchases.history',
                  component: purchasesHistory,
                  meta: { name: 'history', userType: 'provider', serviceTypes: 'all' }
                }
              ]
            },
            {
              path: 'gifts',
              name: 'customers.management.gifts',
              component: accountsDetailsGifts,
              redirect: { name: 'customers.management.gifts.current' },
              meta: { name: 'gifts', userType: 'provider', serviceTypes: 'all' },
              children: [
                {
                  path: 'current',
                  name: 'customers.management.gifts.current',
                  component: giftsCurrent,
                  meta: { name: 'current', userType: 'provider', serviceTypes: 'all' }
                },
                {
                  path: 'history',
                  name: 'customers.management.gifts.history',
                  component: giftsHistory,
                  meta: { name: 'history', userType: 'provider', serviceTypes: 'all' }
                }
              ]
            },
            {
              path: 'services',
              name: 'customers.management.services',
              component: accountsDetailsServices,
              meta: { name: 'services', userType: 'provider', serviceTypes: 'all' }
            }
          ]
        }
      ]
    },
    {
      path: 'account',
      name: 'customers.accountsDetails',
      component: accountsDetails,
      redirect: to => ({ name: 'customers.accountsDetails.purchases', params: to.params }),
      meta: { name: 'accountsDetails', userType: 'provider', serviceTypes: 'all' },
      children: [
        {
          path: 'purchases/:id?',
          name: 'customers.accountsDetails.purchases',
          component: accountsDetailsPurchases,
          redirect: to => ({ name: 'customers.accountsDetails.purchases.current', params: to.params }),
          meta: { name: 'purchases', userType: 'provider', serviceTypes: 'all' },
          children: [
            {
              path: 'current',
              name: 'customers.accountsDetails.purchases.current',
              component: purchasesCurrent,
              meta: { name: 'current', userType: 'provider', serviceTypes: 'all' }
            },
            {
              path: 'history',
              name: 'customers.accountsDetails.purchases.history',
              component: purchasesHistory,
              meta: { name: 'history', userType: 'provider', serviceTypes: 'all' }
            }
          ]
        },
        {
          path: 'gifts/:id?',
          name: 'customers.accountsDetails.gifts',
          component: accountsDetailsGifts,
          redirect: to => ({ name: 'customers.accountsDetails.gifts.current', params: to.params }),
          meta: { name: 'gifts', userType: 'provider', serviceTypes: 'all' },
          children: [
            {
              path: 'current',
              name: 'customers.accountsDetails.gifts.current',
              component: giftsCurrent,
              meta: { name: 'current', userType: 'provider', serviceTypes: 'all' }
            },
            {
              path: 'history',
              name: 'customers.accountsDetails.gifts.history',
              component: giftsHistory,
              meta: { name: 'history', userType: 'provider', serviceTypes: 'all' }
            }
          ]
        },
        {
          path: 'services/:id?',
          name: 'customers.accountsDetails.services',
          component: accountsDetailsServices,
          meta: { name: 'services', userType: 'provider', serviceTypes: 'all' }
        }
      ]
    }]
  }
]
